import apiClient from '../config/axiosConfig.js';

// ─── Notes / Comments API ───────────────────────────────────────────────────
// Backend routes live under /api/files. Auth + workspace header are attached
// automatically by apiClient. Errors are allowed to propagate to the caller.

/**
 * Lists all notes for a file.
 * GET /api/files/notes?id=<fileId>
 * @param {string} fileId
 * @returns {Promise<Array>} Note[]
 */
export async function listNotes(fileId) {
    const response = await apiClient.get('/api/files/notes', { params: { id: fileId } });
    return response.data;
}

/**
 * Creates a new note on a file.
 * POST /api/files/notes?id=<fileId>  body { text }
 * @param {string} fileId
 * @param {string} text
 * @returns {Promise<{ success: boolean, note: Object }>}
 */
export async function createNote(fileId, text) {
    const response = await apiClient.post('/api/files/notes', { text }, { params: { id: fileId } });
    return response.data;
}

/**
 * Updates an existing note (text and/or done state).
 * PATCH /api/files/notes?id=<fileId>&noteId=<noteId>  body { text?, done? }
 * @param {string} fileId
 * @param {string} noteId
 * @param {{ text?: string, done?: boolean }} patch
 * @returns {Promise<{ success: boolean, note: Object }>}
 */
export async function updateNote(fileId, noteId, patch) {
    const response = await apiClient.patch('/api/files/notes', patch, {
        params: { id: fileId, noteId }
    });
    return response.data;
}

/**
 * Deletes a note.
 * DELETE /api/files/notes?id=<fileId>&noteId=<noteId>
 * @param {string} fileId
 * @param {string} noteId
 * @returns {Promise<{ success: boolean }>}
 */
export async function deleteNote(fileId, noteId) {
    const response = await apiClient.delete('/api/files/notes', {
        params: { id: fileId, noteId }
    });
    return response.data;
}
